import { Chip } from "@mui/material";
import { StoryState } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const STATUS_RESOURCES = Resources.Stories.Management.Status;

const CHIP_COLORS: Record<StoryState, "default" | "success" | "warning"> = {
  [StoryState.Draft]: "default",
  [StoryState.Live]: "success",
  [StoryState.Expired]: "default",
  [StoryState.Unpublished]: "warning",
};

type Props = {
  state: StoryState;
};

export const StoryStatusChip = ({ state }: Props) => {
  const { t } = useResource();

  const labels: Record<StoryState, string> = {
    [StoryState.Draft]: t(STATUS_RESOURCES.Draft),
    [StoryState.Live]: t(STATUS_RESOURCES.Live),
    [StoryState.Expired]: t(STATUS_RESOURCES.Expired),
    [StoryState.Unpublished]: t(STATUS_RESOURCES.Unpublished),
  };

  return (
    <Chip
      label={labels[state]}
      size="small"
      color={CHIP_COLORS[state]}
      variant={state === StoryState.Expired ? "outlined" : "filled"}
    />
  );
};
